import IMAGES from '../const/images';

const checkDriverStatus = (isBusy: boolean, onDutyFlag: boolean) => {
    let status = 'OFFLINE';
    if (!isBusy && onDutyFlag) status = 'ONLINE';
    if (isBusy && onDutyFlag) status = 'BUSY';
    return status;
};

const driverMarkerImage = (status: string) => {
    let image = IMAGES.driver.offline;

    switch (status) {
    case 'ONLINE': {
        image = IMAGES.driver.online;
        break;
    }
    case 'BUSY': {
        image = IMAGES.driver.busy;
        break;
    }
    default:
        break;
    }

    return image;
};

export { checkDriverStatus, driverMarkerImage };
